import { HTMLProps, useState } from 'react';
import IcBadgePlaceholder from 'src/assets/images/icPlaceholder.svg';
interface Props extends Pick<HTMLProps<HTMLImageElement>, 'alt' | 'className'> {
  src?: string;
  alt?: string;
  showFallback?: boolean;
  className?: string;
}
const BadgeImage = ({
  src,
  alt = 'Quality User Badge',
  showFallback = false,
  className
}: Props) => {
  const [hasError, setHasError] = useState(false);
  if (hasError && showFallback) {
    return <IcBadgePlaceholder className={className} />;
  }
  return <img src={src} alt={alt} onError={() => setHasError(true)} className={className} data-sentry-component="BadgeImage" data-sentry-source-file="BadgeImage.tsx" />;
};
export default BadgeImage;